export default __webpack_public_path__ + "static/media/loader-img.3e408253.svg";